import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { saveAuth } from '../services/auth';
import toast from '../services/toast';
import Icon from '../components/Icon';
import './Login.css';

const WHATSAPP_NUMBER = '5574981491871';
const VERSAO = process.env.REACT_APP_VERSAO;

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', senha: '' });
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      const data = await api.post('/auth/login', form);
      saveAuth(data.token, data.user);
      toast.success('Login realizado com sucesso!');
      navigate('/');
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  }

  function handleSuporte() {
    const msg = encodeURIComponent('Olá, preciso de ajuda com minha conta na plataforma Palpitar.');
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`, '_blank');
  }

  return (
    <div className="login-page">
      <span className="login-bg__orb o1" />
      <span className="login-bg__orb o2" />

      <div className="login-inner">
        <div className="login-hero" aria-hidden="true">
          <svg viewBox="0 0 140 120" className="login-hero__fig">
            <defs>
              <linearGradient id="loginFireGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#fff2c9" />
                <stop offset="45%" stopColor="var(--gold)" />
                <stop offset="100%" stopColor="var(--gold-deep)" />
              </linearGradient>
              <filter id="loginFireGlow" x="-60%" y="-60%" width="220%" height="220%">
                <feGaussianBlur stdDeviation="1.6" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <g className="trails">
              <path d="M4 66 H46" /><path d="M10 74 H50" /><path d="M2 82 H40" />
            </g>
            <g className="figure" filter="url(#loginFireGlow)">
              <circle className="head" cx="70" cy="24" r="8.5" />
              <path className="torso" d="M67 33 C63 42 62 50 66 58" />
              <path d="M65 36 C54 33 44 28 36 21" />
              <path d="M69 37 C79 41 86 44 93 41" />
              <path d="M66 58 C61 68 58 80 55 95" />
              <path d="M66 58 C78 60 90 57 104 47" />
              <circle className="ball" cx="112" cy="42" r="7" />
              <path className="ball-seam" d="M107 40 L117 44 M112 36v12" />
            </g>
            <g className="sparks">
              <circle cx="20" cy="52" r="1.6" /><circle cx="96" cy="20" r="1.3" />
              <circle cx="30" cy="90" r="1.4" /><circle cx="118" cy="60" r="1.2" />
            </g>
          </svg>
        </div>

        <div className="login-card">
          {VERSAO && <span className="version-badge">{VERSAO}</span>}
          <h1 className="login-card__title">Palpitar</h1>
          <p className="login-card__sub">Ganhe prêmios, recompensas e vantagens <span className="login-card__destaque">exclusivas</span>.</p>

          {erro && <div className="alert alert-error">{erro}</div>}

          <form onSubmit={handleSubmit}>
            <div className="pillfield">
              <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required placeholder="seu@email.com" />
              <span className="pillfield__badge"><Icon name="mail" size={15} /></span>
            </div>
            <div className="pillfield">
              <input type="password" value={form.senha} onChange={e => setForm({ ...form, senha: e.target.value })} required placeholder="••••••••" />
              <span className="pillfield__badge"><Icon name="lock" size={15} /></span>
            </div>

            <Link to="/esqueceu-senha" className="login-linklike">Esqueci minha senha</Link>

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          <button className="btn btn-secondary btn-block" style={{ marginTop: 10 }} onClick={handleSuporte}>
            <Icon name="chat" size={13} /> Entrar em contato com o suporte
          </button>

          <Link to="/cadastro" className="cupom-cta">
            <span className="cupom-cta__icon"><Icon name="gift" size={18} /></span>
            <span className="cupom-cta__label">Possui um cupom?</span>
            <Icon name="chevron" size={16} />
          </Link>

          <p className="login-card__foot">Não tem conta? <Link to="/cadastro">Cadastre-se</Link></p>
          <p className="login-card__dev">Desenvolvido por Damelsoft</p>
        </div>
      </div>
    </div>
  );
}
